import { useEffect, useState } from 'react';
import '../../Ensino.css';

import Header from '../../../../componentes/js/Header';
import Footer from '../../../../componentes/js/Footer';
import Modal from '../../../../componentes/js/Modal';
import LivrosCarousel from '../../../../componentes/js/LivrosCarrossel';
import dadosLivros from '../../../../dados/livros.json';
import { ANO_CALENDARIO } from '../../../../config/anoLetivo';
import CalendarioImagens from '../../../../componentes/js/CalendarioImagens';

function EnsinoFundamental1() {
  const materiais = [
    {
      ano: "1º Ano",
      pdfUrl: "assets/pdf/listaMateriais/fund1/materiais1Ano.pdf"
    },
    {
      ano: "2º Ano",
      pdfUrl: "assets/pdf/listaMateriais/fund1/materiais2Ano.pdf"
    },
    {
      ano: "3º Ano",
      pdfUrl: "assets/pdf/listaMateriais/fund1/materiais3Ano.pdf"
    },
    {
      ano: "4º Ano",
      pdfUrl: "assets/pdf/listaMateriais/fund1/materiais4Ano.pdf"
    },
    {
      ano: "5º Ano",
      pdfUrl: "assets/pdf/listaMateriais/fund1/materiais5Ano.pdf"
    }
  ];

  // Lista de livros guardada no próprio site (src/dados/livros.json)
  const livros = dadosLivros.fundamental1;
  const [activeCard, setActiveCard] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  const steps = [
    {
      number: 1,
      color: "#ff9900",
      title: (
        <>
          Acesse o link:{" "}
          <a
            href="https://educarlivros.com/escola"
            style={{color:"#ff7700ff"}}
            target="_blank"
            rel="noopener noreferrer"
          >
            educarlivros.com/escola
          </a>
        </>
      ),
      description: (
        <>
          Informe o código da lista, fornecido pela Escola.{" "}
          <strong>Código: GO-0033</strong>
        </>
      ),
      logo: {
        url: "assets/images/logo/colegio-lider.png",
        text: "Disponibilizado pelo Colégio Líder",
      },
      icon: "https://cdn-icons-png.flaticon.com/512/841/841364.png",
    },
    {
      number: 2,
      color: "#f44336",
      title: "Selecione a sua lista e identifique-se",
      description:
        "Faça sua identificação ou efetue um novo cadastro. O cadastramento permite acompanhar a situação de seus pedidos e efetuar novas compras.",
      icon: "https://cdn-icons-png.flaticon.com/512/1077/1077012.png",
    },
    {
      number: 3,
      color: "#2196f3",
      title: "Adicione a lista ao carrinho",
      description:
        "Ao adicionar a lista ao carrinho será solicitado que informe o nome do aluno.",
      icon: "https://cdn-icons-png.flaticon.com/512/1170/1170678.png",
    },
    {
      number: 4,
      color: "#9c27b0",
      title: "Pagamento e Entrega",
      description:
        "Selecione o tipo de entrega: Receber em casa (cobrado frete) ou Receber na escola (frete grátis). Disponibilizamos três formas de pagamento: boleto bancário, pix e cartão de crédito.",
      icon: "https://cdn-icons-png.flaticon.com/512/126/126509.png",
    },
    {
      number: 5,
      color: "#8bc34a",
      title: "Confirmação do pedido",
      description:
        "Pedido realizado com sucesso. Você também receberá por e-mail a confirmação do pedido.",
      icon: "https://cdn-icons-png.flaticon.com/512/845/845646.png",
    },
  ];

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
      setIsMobile(true);
    }
  }, []);  

  const cardContents = {
    'Educacao': {
      title: 'Educação Financeira e Empreendedorismo',
      text: 'Em conjunto, a educação financeira e o empreendedorismo formam uma base robusta que capacita nossos jovens a serem líderes em suas comunidades, preparados para enfrentar os desafios do mundo moderno com confiança e competência. Em nosso colégio, estamos comprometidos em equipá-los com essas ferramentas essenciais para que possam construir um futuro próspero e sustentável.',
      imageUrl: 'assets/images/educacao.jpeg',
    },
    'CNA': {
      title: 'CNA Inglês',
      text: 'Aqui, nós apoiamos o seu aprendizado de forma leve, divertida e personalizada. Você conversa com o mundo enquanto nós imaginamos um futuro cheio de possibilidades junto com você. No CNA, você pode acreditar!',
      videoUrl: 'https://www.youtube.com/embed/EF2CTjsamiI?vq=hd1080',
    },
    'SEE': {
      title: 'SEE',
      text: 'O Programa de Socioemocional e Ética (PSEE) é o processo pelo qual crianças, jovens e adultos adquirem e aplicam o conhecimento, as habilidades e atitudes para desenvolverem identidades  saudáveis, gerenciar emoções, alcançar metas pessoais e coletivas, sentir e demonstrar empatia pelos outros, estabelecer e manter relações solidárias bem como tomar decisões responsáveis, cuidadosas e orientadas por valores éticos.',
      imageUrl: 'assets/images/see.png',
    }
  };

  return (
    <div style={{backgroundImage: 'url(assets/images/fundo/fundo2.png)', backgroundSize: isMobile ? '60%' : '25%', backgroundPosition: 'center', backgroundRepeat: 'repeat', marginBottom: '-16vh'}}>
      <Header />
      <main>
      <div className="escola">
        <header>
          <div className='tituloEscola'><h2 className='titulo-secao' style={{ fontSize: 40 + 'px'}}>Ensino Fundamental I</h2></div>
          <p>Sistema de Ensino</p>
          <div className='sistemaContainer'>
            <a href='https://www.plurall.net/' rel='noreferrer' target='_blank'>
              <div className='itensSistema'>
                <img src='assets/images/sistemas/plurall.png' alt='Plurall'/>
                PLURALL
              </div>
            </a>
          </div>
        </header>
        <section className="ensino" style={{backgroundColor: '#fffefe', padding: '12px', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)'}}>
          <p style={{margin: 0}}>
          No Ensino Fundamental I, o ensino é projetado para ser envolvente e relevante para as 
          crianças. Utilizando atividades que capturam a imaginação dos alunos, a educação nessa 
          fase é fortemente conectada às suas experiências diárias. É nesse período que os alunos 
          desenvolvem habilidades essenciais como leitura, escrita e matemática de maneira concreta.
           A educação nesse nível também enfatiza a importância da independência, do comportamento ético
            e da colaboração. Com abordagens que estimulam tanto a curiosidade quanto a expressão individual, 
            os estudantes não apenas adquirem conhecimentos fundamentais, mas também cultivam uma base sólida 
            para o aprendizado contínuo e o sucesso futuro na escola.
          </p>
        </section>
        <section className="atividades">
          <h2 className='titulo-secao'>Projetos e Iniciativas</h2>
          <div className="cartas">
            <div className="carta" onClick={() => setActiveCard('Educacao')}>
              <h3>Educação Financeira e Empreendedorismo</h3>
            </div>
            <div className="carta" onClick={() => setActiveCard('CNA')}>
              <h3>CNA Inglês</h3>
            </div>
            <div className="carta" onClick={() => setActiveCard('SEE')}>
              <h3>SEE</h3>
            </div>
          </div>
        </section>

        <section className="calendario">
          <div style={{display: 'flex', flexDirection: 'row', textAlign: 'center', alignItems: 'center', gap: '15px'}}>
            <h2 className='titulo-secao'>Calendário {ANO_CALENDARIO}</h2>
            <p><a href='/materiais' style={{color: '#333'}}>Procurando a lista de materiais? <span style={{textDecoration: 'underline'}}>Clique aqui!</span></a></p>
          </div>
          <CalendarioImagens segmento='Ensino Fundamental I' paginas={['fund1a.png', 'fund1b.png']} />
        </section>

        <Modal
          show={!!activeCard}
          onClose={() => setActiveCard(null)}
          title={cardContents[activeCard]?.title}
          text={cardContents[activeCard]?.text}
          imageUrl={cardContents[activeCard]?.imageUrl}
          videoUrl={cardContents[activeCard]?.videoUrl}
        />

        <section className="livros">
          <h2 className='titulo-secao'>Livros</h2>
          <div className='containerLivros' style={{display: "flex"}}>
            <div className='informacoesLivros'>
              {steps.map((step) => (
                <div
                  key={step.number}
                  className="step"
                  style={{ backgroundColor: step.color + "99" }}
                >
                  {step.logo && (
                    <div className="school-logo">
                      <span className="logo-text">{step.logo.text}</span>
                      <img
                        src={step.logo.url}
                        alt="Logo da escola"
                        className="logo-img"
                      />
                    </div>
                  )}
                  <div
                    className="step-icon"
                    style={{ backgroundColor: step.color }}
                  >
                    <img
                      src={step.icon}
                      alt={`Ícone etapa ${step.number}`}
                      width="30"
                      height="30"
                    />
                  </div>
                  <div className="step-content">
                    <h2 className='titulo-secao' style={{ color: step.color }}>
                      {step.number}. {step.title}
                    </h2>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            <button style={{fontSize: '4vh'}}><a href="https://educarlivros.com/escola" target='_blank' rel='noreferrer'>Comprar agora</a></button>
            </div>
            <LivrosCarousel livros={livros}/>
          </div>
        </section>
        <section className="materiaisSection">
          <h2 className='titulo-secao'>Lista de Materiais</h2>
          <p className="materiaisSubtitle">
            Acesse abaixo as listas de materiais em PDF.
          </p>

          <div className="materiaisGrid">
            {materiais.map((item) => (
            <a
              key={item.ano}
              href={item.pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="materialCard"
            >
            <div className="materialHeader">
              <span className="materialAno">{item.ano}</span>
              <span className="materialPdf">PDF</span>
            </div>
            <p className="materialText">
              Clique para abrir ou baixar a lista de materiais do {item.ano}.
            </p>
            </a>
            ))}
          </div>
        </section>
      </div>
      </main>
      <Footer />
    </div>
  );
}

export default EnsinoFundamental1;